import {
  BRANCHPOINT_TOOLTIP,
  TIMELINE_SPINE_PLAN,
} from '../planATimelineDiagramModel'
import { type TimelinePlacement } from '../timelineDiagramLayout'
import { branchpointNavOpts } from '../timelineDiagramNavigation'
import { type DiagramNavigate } from '../useTimelineDiagramNavigation'
import { DiagramLabel } from './DiagramLabel'

// The branchpoint titles lifted to the row just above the spine, each sitting at
// the top of its rising arrow. Clicking one makes Plan A active and opens +
// scrolls to that branchpoint's "Alternate Timeline" box. Positions come from
// PLACEMENT.
export const BranchpointLabels = ({
  placement,
  onNavigate,
}: {
  placement: TimelinePlacement
  onNavigate: DiagramNavigate
}) => (
  <>
    {placement.branchpoints.map(({ entry, labelAt }) => (
      <DiagramLabel
        key={entry.detailsId}
        x={labelAt.x}
        y={labelAt.y}
        anchor="center"
        overlay
        tooltip={BRANCHPOINT_TOOLTIP[entry.detailsId]}
        onClick={() => onNavigate(TIMELINE_SPINE_PLAN, branchpointNavOpts(entry))}
      >
        {entry.label}
      </DiagramLabel>
    ))}
  </>
)
